import querystring from 'querystring'

export default (params) => {
    const typeKeys = Object.keys(params.types)
    return params.airports.split(',')
        .filter(Boolean)
        .filter((val, id, array) => array.indexOf(val) === id)
        .map((airport) => {
            let queryParams = querystring.stringify({
                airportId: airport.trim(),
                begin: params.begin,
                end: params.end,
                count: params.count,
                type: typeKeys.filter(key => key !== 'All' && params.types[key])
            })
            return '/api/fb/weather/airport?' + queryParams
        })
}


// WEBPACK FOOTER //
// ./src/screens/weather/utils/formatWeatherUrlQueries.js